const CONSTANTS = module.exports = {};

// Number of days to shift each cancellation-policy window boundary earlier.
// Keyed by supplier name (CONSTANTS.SUPPLIERS values). `default` applies to any
// supplier without an explicit override.
CONSTANTS.CANCEL_POLICY_BUFFER_DAYS = {
    default: 1
};
